var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"app",attrs:{"direction":"vertical"}},[_c('start'),_c('ent-member'),_c('ent-prj-cfg'),_c('sel-todo'),_c('state-hint'),_c('dice-draw-result'),_c('task-board'),_c('summarize')],1)}
var staticRenderFns = []

export { render, staticRenderFns }